import React from 'react';
import { ModalTransition as AKModalTransition } from '@atlaskit/modal-dialog';
import { isReducedMotion } from '@atlaskit/motion';
import { useMinimizableModal, TransitionState } from '../../../controllers/use-minimizable-modal';
import type { ModalTransitionProps } from './types';

export const ModalTransition = ({ children, renderCondition }: ModalTransitionProps) => {
	const { isTransitionInState } = useMinimizableModal();

	if (isReducedMotion()) {
		if (renderCondition) {
			return <>{children}</>;
		}
		return null;
	}

	const shouldRenderModalView =
		renderCondition && isTransitionInState(['mini', 'minimized'], TransitionState.EXITED);

	return <AKModalTransition>{shouldRenderModalView && children}</AKModalTransition>;
};
